import React from 'react'
import {
  FileSearchOutlined,
  FileSyncOutlined,
  BarsOutlined,
  DownloadOutlined,
  // FileSyncOutlined
  UserOutlined,
  // UnorderedListOutlined,
  UsergroupAddOutlined,
  TeamOutlined,
  PictureOutlined
} from '@ant-design/icons'
// import Welcome from '@/pages/welcome/Welcome'
import UserManagement from '@/pages/UserManagement/UserManagement'
import RoleManagement from '@/pages/RoleManagement/RoleManagement'
import byBatchPage from '@/pages/orderQuery/byBatch'
import downloadTaskPage from '@/pages/orderQuery/downloadTask'
import AbnormalQueryPage from '@/pages/abnormal/abnormalQuery'
import ReceiptDataPage from '@/pages/returnReport/receiptData'
import WhOperationPage from '@/pages/returnReport/whOperation'
import ListModePage from '@/pages/cGrade/listMode'
// import ImagesModePage from '@/pages/cGrade/imagesMode'
// import bySinglePage from '@/pages/orderQuery/bySingle'

const routerConfig = [
  {
    key: '/returnreport',
    label: 'Return Report',
    labelEn: 'Return Report',
    labelZh: '退货报表',
    icon: <BarsOutlined />,
    hidden: false,
    children: [
      {
        key: '/returnreport/whoperation',
        label: 'WH Operation',
        labelEn: 'WH Operation',
        labelZh: '仓库运维报表',
        hidden: false,
        permission: ['menu_cro_whOperation'],
        component: WhOperationPage
      }
    ]
  },
  {
    key: '/orderquery',
    label: 'Return Order Query',
    labelEn: 'Return Order Query',
    labelZh: '退换货订单查询',
    icon: <FileSearchOutlined />,
    hidden: false,
    children: [
      {
        key: '/orderquery/bybatch',
        label: 'By Batch',
        labelEn: 'By Batch',
        labelZh: '批量查询',
        hidden: false,
        permission: ['menu_cro_dataFoundation'],
        component: byBatchPage
      },
      {
        key: '/returnreport/receiptdata',
        label: 'Receipt Data',
        labelEn: 'Receipt Data',
        labelZh: '入库单数据',
        hidden: false,
        permission: ['menu_cro_receiptData'],
        component: ReceiptDataPage
      }
      // {
      //   key: '/orderquery/bysingle',
      //   label: 'By Single Return Order',
      //   labelEn: 'By Single Return Order',
      //   labelZh: '单条查询',
      //   hidden: false,
      //   permission: ['menu_cro_dataFoundation_full'],
      //   component: bySinglePage
      // }
    ]
  },
  {
    key: '/abnormalquery',
    label: '异常件查询',
    labelEn: '异常件查询',
    labelZh: '异常件查询',
    icon: <FileSyncOutlined />,
    hidden: false,
    permission: ['menu_cro_abnormalQuery'],
    component: AbnormalQueryPage
  },
  {
    key: '/cgrade',
    label: 'Defective Product Picture',
    labelEn: 'Defective Product Picture',
    labelZh: 'Defective Product Picture',
    icon: <PictureOutlined />,
    hidden: false,
    permission: ['menu_cro_cGradeQuery'],
    component: ListModePage
  },
  // {
  //   key: '/cgrade',
  //   label: 'C品图片查询',
  //   labelEn: 'C品图片查询',
  //   labelZh: 'C品图片查询',
  //   icon: <PictureOutlined />,
  //   hidden: false,
  //   children: [
  //     {
  //       key: '/cgrade/imagesmode',
  //       label: '图片模式',
  //       labelEn: '图片模式',
  //       labelZh: '图片模式',
  //       hidden: false,
  //       permission: ['menu_cro_cGradePictoryQuery'],
  //       component: ImagesModePage
  //     },
  //     {
  //       key: '/cgrade/listmode',
  //       label: '列表模式',
  //       labelEn: '列表模式',
  //       labelZh: '列表模式',
  //       hidden: false,
  //       permission: ['menu_cro_cGradeQuery'],
  //       component: ListModePage
  //     }
  //   ]
  // },
  {
    key: '/downloadtask',
    label: 'Download Task',
    labelEn: 'Download Task',
    labelZh: '下载任务',
    icon: <DownloadOutlined />,
    hidden: false,
    permission: ['menu_cro_downloadTask'],
    component: downloadTaskPage
  },
  {
    key: '/user',
    label: '用户',
    labelEn: '用户',
    labelZh: '用户',
    icon: <UsergroupAddOutlined />,
    hidden: false,
    children: [
      {
        key: '/user/rolemanagement',
        label: '角色管理',
        labelEn: '角色管理',
        labelZh: '角色管理',
        icon: <TeamOutlined />,
        // hidden: true,
        permission: ['menu_role_management'],
        component: RoleManagement
      },
      {
        key: '/user/usermanagement',
        label: '用户管理',
        labelEn: '用户管理',
        labelZh: '用户管理',
        icon: <UserOutlined />,
        // hidden: true,
        permission: ['menu_user_management'],
        component: UserManagement
      }
    ]
  }
]
export default routerConfig
